import Vue from 'vue'
import App from './App.vue'
import router from '@router'
import Toasted from 'vue-toasted'
import VueLoading from 'vue-loading-overlay'
import 'animate.css'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.min.css'
//fontawesome
import '@fortawesome/fontawesome-free/css/all.css'
//bootstrap
import 'bootstrap/dist/js/bootstrap.js'

//VTooltip
import VTooltip from 'v-tooltip'

import './assets/sass/global.scss'

import 'vue-progress-path/dist/vue-progress-path.css'
import VueProgress from 'vue-progress-path'
Vue.use(VueProgress)

import VModal from 'vue-js-modal'
Vue.use(VModal)

import utils from '@utils/index.js'
Vue.use(utils)

import vueSignature from 'vue-signature'
Vue.use(vueSignature)

import { Tabs, Tab } from 'vue-tabs-component'

Vue.component('tabs', Tabs)
Vue.component('tab', Tab)

import VueParticles from 'vue-particles'
Vue.use(VueParticles)

import VeeValidate from 'vee-validate'
const config = {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
}
Vue.use(VeeValidate, config)

// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === 'production'

require('jquery.easing')

Vue.use(VueLoading)
Vue.component('loading', VueLoading)

// moment
Vue.use(require('vue-moment'))
//vue-toasted
Vue.use(Toasted, {
  theme: 'bubble',
  position: 'top-right',
  duration: 5000,
})

//VTooltip
Vue.use(VTooltip)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
